import React from "react"

import SEO from "components/SEO"
import { HeroSection, HowSection } from 'components/HomePage'

const IndexPage = () => (
  <>
    <SEO title="A phone number for creators. Connect with your followers via text message." />
    <HeroSection />
    <HowSection />
  </>
)

export default IndexPage
